import api from "./api";

export const getTipoDocumento = async () => {
    try {
        const response = await api.get("/tipoDocumento_");
        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}